<template>
  <div class="wrap">
    <setup-table ref="setupTable"></setup-table>
    <addTableDialog ref="dataDialog" title="编辑" @initTree="initTree"></addTableDialog>
  </div>
</template>

<script>
import {
  requestFieldList,
  saveListConfigJSON,
  requestFormList,
  requestTableList,
  requestMetaList,
  getListConfigJSON,
  getPrimekey,
  requestAuthorizeList,
  generateQuerySql,
  generateQueryMultiFieldSql,
  saveSql
} from "@/CommonDP/service/listFlow-service";
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import metadataService from "@/CommonDP/service/metadata-service";
import { generalRequest } from "@/CommonDP/utils";
import addTableDialog from "./dialog/addTableDialog";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { componentDicList, componentList } from "@/CommonDP/exportComponentList";
import Sortable from "sortablejs";
import Ace from "ace-builds";
export default {
  components: { addTableDialog },
  data() {
    return {
      requestFieldList,
      saveListConfigJSON,
      requestFormList,
      requestTableList,
      requestMetaList,
      getListConfigJSON,
      getPrimekey,
      generalRequest,
      requestAuthorizeList,
      checkPermission,
      generateQuerySql,
      saveSql,
      pageInfo: {}
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  provide() {
    return {
      componentDicList: componentDicList,
      flowComp: require("@/CommonDP/components/processComponents/flow/flowDialogSummary.vue").default,
      queryFlowDef: flowService.queryFlowDef,
      componentList: componentList,
      queryGenerateMultiFieldSql: generateQueryMultiFieldSql,
      Sortable,
      Ace,
      AceOptions: {},
      requestFieldList: this.requestFieldList,
      getListPageId: () => this.pageInfo.groupId,
      getPageInfo: () => this.pageInfo,
      saveListConfigJSON: this.saveListConfigJSON,
      saveSql: this.saveSql,
      generateQuerySql: this.generateQuerySql,
      requestFormList: this.requestFormList,
      requestTableList: this.requestTableList,
      requestMetaList: this.requestMetaList,
      requestFlowList: this.requestFlowList,
      requestAuthorizeList: this.requestAuthorizeList,
      requestTreeData: this.requestTreeData,
      getListConfigJSON: this.getListConfigJSON,
      requestPrimekey: this.getPrimekey,
      generalRequest: this.generalRequest,
      checkPermission: this.checkPermission,
      showTableSetting: this.showTableSetting,
      enterpriseId: this.enterpriseId,
      getPrjInfo: () => this.prjInfo
    };
  },
  mounted() {
    // this.init()
  },
  methods: {
    init(data) {
      this.pageInfo = {
        ...data
      };
      if (!this.pageInfo.pageLayout) this.pageInfo.pageLayout = "table";
      this.$refs.setupTable.init(data.groupId, data.formCode);
    },
    showTableSetting(index) {
      this.$refs.dataDialog.init(
        {
          listPageId: this.pageInfo.groupId,
          groupId: this.pageInfo.parentId
        },
        index
      );
    },
    initTree() {
      this.$emit("initTree", true, this.pageInfo.groupId);
    },
    requestFlowList() {
      return flowService.queryGroupInfoList(this.enterpriseId).then((res) => {
        console.log(
          res.data.map((item) => {
            return {
              ...item,
              ...item.flowGroupDto
            };
          })
        );
        return res.data.map((item) => {
          return {
            ...item,
            ...item.flowGroupDto
          };
        });
      });
    },
    requestTreeData(params = {}, id) {
      return metadataService.dynamicTreeData(params, id).then((res) => {
        // res.data = res.data.slice(0, 40);
        return res;
      });
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.wrap {
   width: 100%;
  height: 100%;
    /deep/ .el-table--border .el-table__cell:first-child .cell {    padding-left: 5px;
  }
   /deep/  .el-table th.el-table__cell > .cell {
    padding-right: 5px
  }
}
.content {
  width: 100%;
  height: 100%;
}
.btnDesign {
  margin:  20px 56px;
}
.middle {
  position: relative;
  left: -8px;
  top: -20px;
  font-size: 16px;
}
.top {
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  align-items: center
}
::v-deep .tablesetup{
  .wrap{
    margin-top: 0;
    display: flex;
    flex-direction: column;
    .operate{
      padding-top: 10px;
    }
    .renderwrap{
      height: 1px;
      flex-grow: 1;
    }
  }
}
</style>
